import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';

import { medicalExamination } from '../../../../model/medicalexamination';
import { MexItem } from './MexItem';

interface IProps extends StyledComponentProps {
    medicalExaminationList: Array<medicalExamination>;
    onMedicalExaminationClick: (sub: string) => void;
    selected: string;
}

export const MexList = (props: IProps) => {
    const classes = props.classes;

    const onButtonClick = (item: any) => {
        console.log("onButtonClick 3:", item)
        props.onMedicalExaminationClick(item);
    };

    return (
        <List className={classes.root}>
            {props.medicalExaminationList && props.medicalExaminationList.map((c, index) =>
                <MexItem
                    classes={classes}
                    isSelected={props.selected === c._id}
                    medicalExamination={c}
                    onMedicalExaminationClick={onButtonClick}
                    key={c.sub + index}
                />)}
        </List>)
};